// href: string = real link | null = coming soon (renders as plain text)
const cols: { links: { href: null | string; label: string }[]; title: string }[] = [
  {
    links: [
      { href: '#turfs', label: 'Browse Turfs' },
      { href: '#how', label: 'How It Works' },
      { href: 'https://portal.turfchale.com', label: 'For Owners' },
      { href: '#owners', label: 'Pricing' },
    ],
    title: 'Platform',
  },
  {
    links: [
      { href: null, label: 'Football' },
      { href: null, label: 'Cricket' },
      { href: null, label: 'Badminton' },
      { href: null, label: 'Basketball' },
    ],
    title: 'Sports',
  },
  {
    links: [
      { href: null, label: 'About Us' },
      { href: null, label: 'Blog' },
      { href: null, label: 'Careers' },
      { href: null, label: 'Contact' },
    ],
    title: 'Company',
  },
]

const legalLinks = [
  { href: '/privacy', label: 'Privacy Policy' },
  { href: '/terms', label: 'Terms of Service' },
  { href: '/refund', label: 'Refund Policy' },
  { href: '/legal/player-agreement', label: 'Player Agreement' },
]

export function Footer() {
  return (
    <footer
      className="border-t px-6 md:px-12 pt-14 pb-8 max-w-7xl mx-auto"
      style={{ borderColor: 'var(--lime-line)' }}
    >
      <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
        <div>
          <div className="font-display text-xl font-bold mb-3" style={{ color: 'var(--lime)' }}>
            Turf<span style={{ color: 'var(--text)' }}>Chale</span>
          </div>
          <p
            className="text-sm leading-relaxed font-light max-w-50"
            style={{ color: 'var(--muted)' }}
          >
            India's fastest growing turf booking platform. Find, book, and play — effortlessly.
          </p>
        </div>
        {cols.map((col) => (
          <div key={col.title}>
            <h4
              className="text-xs font-bold tracking-widest uppercase mb-4"
              style={{ color: 'var(--text-dim)' }}
            >
              {col.title}
            </h4>
            <ul className="flex flex-col gap-3">
              {col.links.map(({ href, label }) => (
                <li key={label}>
                  {href ? (
                    <a
                      className="text-sm transition-colors duration-200"
                      href={href}
                      onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--lime)')}
                      onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--muted)')}
                      style={{ color: 'var(--muted)' }}
                      {...(href.startsWith('http')
                        ? { rel: 'noopener noreferrer', target: '_blank' }
                        : {})}
                    >
                      {label}
                    </a>
                  ) : (
                    <span className="text-sm" style={{ color: 'var(--text-dim)' }}>
                      {label}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div
        className="flex flex-col md:flex-row items-center justify-between gap-4 pt-6 border-t"
        style={{ borderColor: 'var(--lime-line)' }}
      >
        <p className="text-xs" style={{ color: 'var(--text-dim)' }}>
          © 2026 TurfChale. All rights reserved.
        </p>
        <div className="flex gap-6">
          {legalLinks.map(({ href, label }) => (
            <a
              className="text-xs transition-colors"
              href={href}
              key={label}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--muted)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--text-dim)')}
              style={{ color: 'var(--text-dim)' }}
            >
              {label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  )
}
